import * as React from "react"
import type { SVGProps } from "react"
const SvgArrowUpRight = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="currentColor"
    viewBox="0 0 24 24"
    {...props}
  >
    <path d="m15.81 9.74-7.9 7.91q-.3.3-.71.3a1 1 0 0 1-.71-.3 1 1 0 0 1-.3-.7q0-.41.3-.72l7.9-7.9H7.46a1 1 0 0 1-.7-.29 1 1 0 0 1-.27-.71q.01-.4.3-.7a1 1 0 0 1 .7-.3h9.33q.2 0 .38.08.16.09.3.22c.15.13.17.2.23.31q.08.17.08.38v9.34q0 .39-.3.68a1 1 0 0 1-.7.3 1 1 0 0 1-.71-.28 1 1 0 0 1-.3-.72z" />
  </svg>
)
export default SvgArrowUpRight
